import { Outlet } from "react-router-dom";
import { BsArchive, BsFillBuildingsFill, BsFillFileEarmarkTextFill } from "react-icons/bs";
import { MdDashboard } from "react-icons/md";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { BiSupport } from "react-icons/bi";
import Sidebar from "../components/shared/sidebar/Sidebar";
import EnergoNavbar from "../components/shared/navbar/EnergoNavbar";
import { useSidebar } from "../context/SidebarContext";
import { motion } from "framer-motion";
import { HwEmployeeProvider } from "../context/HwEmployeeContext";


const HwLayout = () => {

    const { isExpanded, setIsExpanded } = useSidebar();
    const menuOptions = [
        { id: "dashboard", icon: <MdDashboard />, text: "Dashboard", link: "/hw/dashboard/" },
        { id: "gebäude", icon: <BsFillBuildingsFill />, text: "Verwaltete Gebäude", link: "/hw/dashboard/gebaeude/" },
        { id: "elvs", icon: <BsFillFileEarmarkTextFill />, text: "Energielieferverträge", link: "/hw/dashboard/energieliefervertraege/" },
        { id: "download", icon: <AiOutlineCloudDownload />, text: "Downloadbereich", link: "/hw/dashboard/download/" },
        { id: "archiv", icon: <BsArchive />, text: "Archiv", link: "/hw/dashboard/archive/" },
        { id: "support", icon: <BiSupport />, text: "Support", link: "/hw/dashboard/support/" },
    ];

    return (
        <>
            <Sidebar menuOptions={menuOptions} toggleSidebar={isExpanded} setToggleSidebar={setIsExpanded} />
            <motion.div 
                className="sb-content"
                animate={{ marginLeft: isExpanded ? 230 : 60 }}
                transition={{ duration: 0.3 }}
                style={isExpanded ? { marginLeft: 230 } : { marginLeft: 60 }} 
            >
                <EnergoNavbar menuOptions={menuOptions} hasSearch isHw />
                <main>
                    <HwEmployeeProvider>
                        <Outlet />
                    </HwEmployeeProvider>
                </main>
            </motion.div>
        </>
    )
}
export default HwLayout;